import React, { useEffect, useState } from 'react'
import useOfferionTranslation from '../store/hooks/useOfferionTranslation'

export const useCountryOptions = (currentValue: string | undefined | null) => {
    const { t } = useOfferionTranslation()

    const options = [
        { value: 'AW' },
        { value: 'AF' },
        { value: 'AO' },
        { value: 'AI' },
        { value: 'AX' },
        { value: 'AL' },
        { value: 'AD' },
        { value: 'AE' },
        { value: 'AR' },
        { value: 'AM' },
        { value: 'AS' },
        { value: 'AQ' },
        { value: 'TF' },
        { value: 'AG' },
        { value: 'AU' },
        { value: 'AT' },
        { value: 'AZ' },
        { value: 'BI' },
        { value: 'BE' },
        { value: 'BJ' },
        { value: 'BQ' },
        { value: 'BF' },
        { value: 'BD' },
        { value: 'BG' },
        { value: 'BH' },
        { value: 'BS' },
        { value: 'BA' },
        { value: 'BL' },
        { value: 'BY' },
        { value: 'BZ' },
        { value: 'BM' },
        { value: 'BO' },
        { value: 'BR' },
        { value: 'BB' },
        { value: 'BN' },
        { value: 'BT' },
        { value: 'BV' },
        { value: 'BW' },
        { value: 'CF' },
        { value: 'CA' },
        { value: 'CC' },
        { value: 'CH' },
        { value: 'CL' },
        { value: 'CN' },
        { value: 'CI' },
        { value: 'CM' },
        { value: 'CD' },
        { value: 'CG' },
        { value: 'CK' },
        { value: 'CO' },
        { value: 'KM' },
        { value: 'CV' },
        { value: 'CR' },
        { value: 'CU' },
        { value: 'CW' },
        { value: 'CX' },
        { value: 'KY' },
        { value: 'CY' },
        { value: 'CZ' },
        { value: 'DE' },
        { value: 'DJ' },
        { value: 'DM' },
        { value: 'DK' },
        { value: 'DO' },
        { value: 'DZ' },
        { value: 'EC' },
        { value: 'EG' },
        { value: 'ER' },
        { value: 'EH' },
        { value: 'ES' },
        { value: 'EE' },
        { value: 'ET' },
        { value: 'FI' },
        { value: 'FJ' },
        { value: 'FK' },
        { value: 'FR' },
        { value: 'FO' },
        { value: 'FM' },
        { value: 'GA' },
        { value: 'GB' },
        { value: 'GE' },
        { value: 'GG' },
        { value: 'GH' },
        { value: 'GI' },
        { value: 'GN' },
        { value: 'GP' },
        { value: 'GM' },
        { value: 'GW' },
        { value: 'GQ' },
        { value: 'GR' },
        { value: 'GD' },
        { value: 'GL' },
        { value: 'GT' },
        { value: 'GF' },
        { value: 'GU' },
        { value: 'GY' },
        { value: 'HK' },
        { value: 'HM' },
        { value: 'HN' },
        { value: 'HR' },
        { value: 'HT' },
        { value: 'HU' },
        { value: 'ID' },
        { value: 'IM' },
        { value: 'IN' },
        { value: 'IO' },
        { value: 'IE' },
        { value: 'IR' },
        { value: 'IQ' },
        { value: 'IS' },
        { value: 'IL' },
        { value: 'IT' },
        { value: 'JM' },
        { value: 'JE' },
        { value: 'JO' },
        { value: 'JP' },
        { value: 'KZ' },
        { value: 'KE' },
        { value: 'KG' },
        { value: 'KH' },
        { value: 'KI' },
        { value: 'KN' },
        { value: 'KR' },
        { value: 'KW' },
        { value: 'LA' },
        { value: 'LB' },
        { value: 'LR' },
        { value: 'LY' },
        { value: 'LC' },
        { value: 'LI' },
        { value: 'LK' },
        { value: 'LS' },
        { value: 'LT' },
        { value: 'LU' },
        { value: 'LV' },
        { value: 'MO' },
        { value: 'MF' },
        { value: 'MA' },
        { value: 'MC' },
        { value: 'MD' },
        { value: 'MG' },
        { value: 'MV' },
        { value: 'MX' },
        { value: 'MH' },
        { value: 'MK' },
        { value: 'ML' },
        { value: 'MT' },
        { value: 'MM' },
        { value: 'ME' },
        { value: 'MN' },
        { value: 'MP' },
        { value: 'MZ' },
        { value: 'MR' },
        { value: 'MS' },
        { value: 'MQ' },
        { value: 'MU' },
        { value: 'MW' },
        { value: 'MY' },
        { value: 'YT' },
        { value: 'NA' },
        { value: 'NC' },
        { value: 'NE' },
        { value: 'NF' },
        { value: 'NG' },
        { value: 'NI' },
        { value: 'NU' },
        { value: 'NL' },
        { value: 'NO' },
        { value: 'NP' },
        { value: 'NR' },
        { value: 'NZ' },
        { value: 'OM' },
        { value: 'PK' },
        { value: 'PA' },
        { value: 'PN' },
        { value: 'PE' },
        { value: 'PH' },
        { value: 'PW' },
        { value: 'PG' },
        { value: 'PL' },
        { value: 'PR' },
        { value: 'KP' },
        { value: 'PT' },
        { value: 'PY' },
        { value: 'PS' },
        { value: 'PF' },
        { value: 'QA' },
        { value: 'RE' },
        { value: 'RO' },
        { value: 'RU' },
        { value: 'RW' },
        { value: 'SA' },
        { value: 'SD' },
        { value: 'SN' },
        { value: 'SG' },
        { value: 'GS' },
        { value: 'SH' },
        { value: 'SJ' },
        { value: 'SB' },
        { value: 'SL' },
        { value: 'SV' },
        { value: 'SM' },
        { value: 'SO' },
        { value: 'PM' },
        { value: 'RS' },
        { value: 'SS' },
        { value: 'ST' },
        { value: 'SR' },
        { value: 'SK' },
        { value: 'SI' },
        { value: 'SE' },
        { value: 'SZ' },
        { value: 'SX' },
        { value: 'SC' },
        { value: 'SY' },
        { value: 'TC' },
        { value: 'TD' },
        { value: 'TG' },
        { value: 'TH' },
        { value: 'TJ' },
        { value: 'TK' },
        { value: 'TM' },
        { value: 'TL' },
        { value: 'TO' },
        { value: 'TT' },
        { value: 'TN' },
        { value: 'TR' },
        { value: 'TV' },
        { value: 'TW' },
        { value: 'TZ' },
        { value: 'UG' },
        { value: 'UA' },
        { value: 'UM' },
        { value: 'UY' },
        { value: 'US' },
        { value: 'UZ' },
        { value: 'VA' },
        { value: 'VC' },
        { value: 'VE' },
        { value: 'VG' },
        { value: 'VI' },
        { value: 'VN' },
        { value: 'VU' },
        { value: 'WF' },
        { value: 'WS' },
        { value: 'XK' },
        { value: 'YE' },
        { value: 'ZA' },
        { value: 'ZM' },
        { value: 'ZW' },
    ]

    const transformed = options.map(e => {
        return { value: e.value, label: t(`Allaround.Country.${e.value}`) }
    })

    transformed.sort((a, b) => a.label.localeCompare(b.label))

    const [countries, setCountries] = useState(transformed)

    useEffect(() => {
        if (currentValue) {
            const hasCurrentValue = options.find(x => x.value == currentValue)

            if (!hasCurrentValue) setCountries([...countries, { label: currentValue, value: currentValue }])
        }
    }, [currentValue])

    return countries
}

export function useStaticCountryOptions() {
    const { t } = useOfferionTranslation()

    const options = [
        { value: 'AW' },
        { value: 'AF' },
        { value: 'AO' },
        { value: 'AI' },
        { value: 'AX' },
        { value: 'AL' },
        { value: 'AD' },
        { value: 'AE' },
        { value: 'AR' },
        { value: 'AM' },
        { value: 'AS' },
        { value: 'AQ' },
        { value: 'TF' },
        { value: 'AG' },
        { value: 'AU' },
        { value: 'AT' },
        { value: 'AZ' },
        { value: 'BI' },
        { value: 'BE' },
        { value: 'BJ' },
        { value: 'BQ' },
        { value: 'BF' },
        { value: 'BD' },
        { value: 'BG' },
        { value: 'BH' },
        { value: 'BS' },
        { value: 'BA' },
        { value: 'BL' },
        { value: 'BY' },
        { value: 'BZ' },
        { value: 'BM' },
        { value: 'BO' },
        { value: 'BR' },
        { value: 'BB' },
        { value: 'BN' },
        { value: 'BT' },
        { value: 'BV' },
        { value: 'BW' },
        { value: 'CF' },
        { value: 'CA' },
        { value: 'CC' },
        { value: 'CH' },
        { value: 'CL' },
        { value: 'CN' },
        { value: 'CI' },
        { value: 'CM' },
        { value: 'CD' },
        { value: 'CG' },
        { value: 'CK' },
        { value: 'CO' },
        { value: 'KM' },
        { value: 'CV' },
        { value: 'CR' },
        { value: 'CU' },
        { value: 'CW' },
        { value: 'CX' },
        { value: 'KY' },
        { value: 'CY' },
        { value: 'CZ' },
        { value: 'DE' },
        { value: 'DJ' },
        { value: 'DM' },
        { value: 'DK' },
        { value: 'DO' },
        { value: 'DZ' },
        { value: 'EC' },
        { value: 'EG' },
        { value: 'ER' },
        { value: 'EH' },
        { value: 'ES' },
        { value: 'EE' },
        { value: 'ET' },
        { value: 'FI' },
        { value: 'FJ' },
        { value: 'FK' },
        { value: 'FR' },
        { value: 'FO' },
        { value: 'FM' },
        { value: 'GA' },
        { value: 'GB' },
        { value: 'GE' },
        { value: 'GG' },
        { value: 'GH' },
        { value: 'GI' },
        { value: 'GN' },
        { value: 'GP' },
        { value: 'GM' },
        { value: 'GW' },
        { value: 'GQ' },
        { value: 'GR' },
        { value: 'GD' },
        { value: 'GL' },
        { value: 'GT' },
        { value: 'GF' },
        { value: 'GU' },
        { value: 'GY' },
        { value: 'HK' },
        { value: 'HM' },
        { value: 'HN' },
        { value: 'HR' },
        { value: 'HT' },
        { value: 'HU' },
        { value: 'ID' },
        { value: 'IM' },
        { value: 'IN' },
        { value: 'IO' },
        { value: 'IE' },
        { value: 'IR' },
        { value: 'IQ' },
        { value: 'IS' },
        { value: 'IL' },
        { value: 'IT' },
        { value: 'JM' },
        { value: 'JE' },
        { value: 'JO' },
        { value: 'JP' },
        { value: 'KZ' },
        { value: 'KE' },
        { value: 'KG' },
        { value: 'KH' },
        { value: 'KI' },
        { value: 'KN' },
        { value: 'KR' },
        { value: 'KW' },
        { value: 'LA' },
        { value: 'LB' },
        { value: 'LR' },
        { value: 'LY' },
        { value: 'LC' },
        { value: 'LI' },
        { value: 'LK' },
        { value: 'LS' },
        { value: 'LT' },
        { value: 'LU' },
        { value: 'LV' },
        { value: 'MO' },
        { value: 'MF' },
        { value: 'MA' },
        { value: 'MC' },
        { value: 'MD' },
        { value: 'MG' },
        { value: 'MV' },
        { value: 'MX' },
        { value: 'MH' },
        { value: 'MK' },
        { value: 'ML' },
        { value: 'MT' },
        { value: 'MM' },
        { value: 'ME' },
        { value: 'MN' },
        { value: 'MP' },
        { value: 'MZ' },
        { value: 'MR' },
        { value: 'MS' },
        { value: 'MQ' },
        { value: 'MU' },
        { value: 'MW' },
        { value: 'MY' },
        { value: 'YT' },
        { value: 'NA' },
        { value: 'NC' },
        { value: 'NE' },
        { value: 'NF' },
        { value: 'NG' },
        { value: 'NI' },
        { value: 'NU' },
        { value: 'NL' },
        { value: 'NO' },
        { value: 'NP' },
        { value: 'NR' },
        { value: 'NZ' },
        { value: 'OM' },
        { value: 'PK' },
        { value: 'PA' },
        { value: 'PN' },
        { value: 'PE' },
        { value: 'PH' },
        { value: 'PW' },
        { value: 'PG' },
        { value: 'PL' },
        { value: 'PR' },
        { value: 'KP' },
        { value: 'PT' },
        { value: 'PY' },
        { value: 'PS' },
        { value: 'PF' },
        { value: 'QA' },
        { value: 'RE' },
        { value: 'RO' },
        { value: 'RU' },
        { value: 'RW' },
        { value: 'SA' },
        { value: 'SD' },
        { value: 'SN' },
        { value: 'SG' },
        { value: 'GS' },
        { value: 'SH' },
        { value: 'SJ' },
        { value: 'SB' },
        { value: 'SL' },
        { value: 'SV' },
        { value: 'SM' },
        { value: 'SO' },
        { value: 'PM' },
        { value: 'RS' },
        { value: 'SS' },
        { value: 'ST' },
        { value: 'SR' },
        { value: 'SK' },
        { value: 'SI' },
        { value: 'SE' },
        { value: 'SZ' },
        { value: 'SX' },
        { value: 'SC' },
        { value: 'SY' },
        { value: 'TC' },
        { value: 'TD' },
        { value: 'TG' },
        { value: 'TH' },
        { value: 'TJ' },
        { value: 'TK' },
        { value: 'TM' },
        { value: 'TL' },
        { value: 'TO' },
        { value: 'TT' },
        { value: 'TN' },
        { value: 'TR' },
        { value: 'TV' },
        { value: 'TW' },
        { value: 'TZ' },
        { value: 'UG' },
        { value: 'UA' },
        { value: 'UM' },
        { value: 'UY' },
        { value: 'US' },
        { value: 'UZ' },
        { value: 'VA' },
        { value: 'VC' },
        { value: 'VE' },
        { value: 'VG' },
        { value: 'VI' },
        { value: 'VN' },
        { value: 'VU' },
        { value: 'WF' },
        { value: 'WS' },
        { value: 'XK' },
        { value: 'YE' },
        { value: 'ZA' },
        { value: 'ZM' },
        { value: 'ZW' },
    ]

    const allCountries = options.map(e => {
        return { value: e.value, label: t(`Allaround.Country.${e.value}`) }
    })

    // transformed.sort((a, b) => a.label.localeCompare(b.label))

    return allCountries
}
